// Copyright (c) StrangeBee 2023

import { Route as SearchHomeRoute } from './List';
export const Routes = [SearchHomeRoute];
